import api from "@/config/api"
import { withLoading } from "@/store/helpers"

export default {
  namespaced: true,
  state: () => ({
    schedules: [],
    loading: false,
    users: [],
    autogenerateProgress: null,
  }),
  getters: {
    autogenerateProgress(state) {
      return state.autogenerateProgress
    }
  },
  mutations: {
    setSchedules(state, schedules) {
      state.schedules = schedules
    },
    setLoading(state, loading) {
      state.loading = loading
    },
    setUsers(state, users) {
      state.users = users
    },
    SET_AUTOGENERATE_PROGRESS(state, progress) {
      state.autogenerateProgress = progress
    }
  },
  actions: {
    async fetchSchedules(context, params) {
      withLoading(async () => {
        const response = await api.get("/schedules", { params })
        context.commit("setSchedules", response.data)
      }, context)
    },

    async fetchUsers(context) {
      withLoading(async () => {
        const response = await api.get("/schedules/users")
        context.commit("setUsers", response.data)
      }, context)
    },

    async createSchedule(context, params) {
      withLoading(async () => {
        const response = await api.post("/schedules", params)
        context.commit("setSchedules", response.data)
      }, context)
    },

    async updateSchedule(context, { id, ...params }) {
      withLoading(async () => {
        const response = await api.put(`/schedules/${id}`, params)
        context.commit("setSchedules", response.data)
      }, context)
    },

    async deleteSchedule(context, { id, params }) {
      withLoading(async () => {
        const response = await api.delete(`/schedules/${id}`, { params })
        context.commit("setSchedules", response.data)
      }, context)
    },

    setAutogenerateProgress(context, progress) {
      context.commit("SET_AUTOGENERATE_PROGRESS", progress)
    }
  }
}